import { Notification } from 'element-ui'

const stackedPositions = ['center', 'bottom-center', 'bottom-left', 'bottom-end']

function normalizeOptions (options) {
  if (!options || typeof options !== 'object' || !stackedPositions.includes(options.position)) {
    return options
  }

  return {
    ...options,
    position: 'bottom-center'
  }
}

function toastNotification (options) {
  return Notification(normalizeOptions(options))
}

toastNotification.close = Notification.close
toastNotification.closeAll = Notification.closeAll

export default toastNotification
